import { Hidden } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { positionTableStyles } from '../../../../../global/constants/theme/styles/tables/position-table';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { Employment } from '../employment-model';
import { PositionView } from './position-view';

interface Props {
    employmentData: Employment;
    emptyMessage: string;
    editDisabled: boolean;
    isStip?: boolean;
}
export function PositionsDisplay(props: Props) {
    const { employmentData, emptyMessage, isStip, editDisabled } = props;

    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const tableClasses = positionTableStyles();
	const labelSettings = epiProps?.labelSettingState?.epiContent;
	const employmentProps = epiProps?.employmentSettingsState?.epiContent;
	if (!employmentData || !employmentData.position_titles || employmentData.position_titles.length === 0) {
		return <p>{emptyMessage}</p>;
	}

    return (
        <div className={tableClasses.positionTable}>
            <Hidden xsDown>
                <div className='position-table-row'>
                    <div className='position-table-cell position-table-cell-date'>
                        <p className='input-label'>{employmentProps?.dateLabel}</p>
                    </div>
                    <div className='position-table-cell position-table-cell-title'>
                        <p className='input-label'>{employmentProps?.positionTitleLabel}</p>
                    </div>
                </div>
            </Hidden>
            {
                employmentData?.position_titles?.map(a => {
                    return (
                        <PositionView
                            key={a.id}
                            position={a}
                            editText={employmentProps?.editLinkText}
                            isStip={isStip}
                            editDisabled={editDisabled}
                            dateLabel={employmentProps?.dateLabel}
                            positionTitleLabel={employmentProps?.positionTitleLabel}
                            presentDateText={labelSettings.presentDateLabel} />
                    );
                })
            }
        </div>
    );
}

PositionsDisplay.defaultProps = {
    isStip: false,
};